// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Preact from "../bindings/Preact.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let makeStyle = (function(s) { return s; });

function getClientY(event) {
  return event.clientY;
}

function getTouchClientY(event) {
  let touches = event.touches;
  let touch = touches[0];
  if (touch !== undefined) {
    return Primitive_option.valFromOption(touch).clientY;
  } else {
    return 0.0;
  }
}

let addWindowListeners = (function(onMouseMove, onTouchMove, onEnd) {
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchmove', onTouchMove, { passive: true });
    window.addEventListener('touchend', onEnd);
  });

let removeWindowListeners = (function(onMouseMove, onTouchMove, onEnd) {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onEnd);
    window.removeEventListener('touchmove', onTouchMove);
    window.removeEventListener('touchend', onEnd);
  });

function Dispenser(props) {
  let __isDisabled = props.isDisabled;
  let onPull = props.onPull;
  let isDisabled = __isDisabled !== undefined ? __isDisabled : false;
  let match = React.useState(() => false);
  let setIsDragging = match[1];
  let isDragging = match[0];
  let match$1 = React.useState(() => 0.0);
  let setDragProgress = match$1[1];
  let dragProgress = match$1[0];
  let startYRef = React.useRef(0.0);
  let handleStart = clientY => {
    if (!isDisabled) {
      setIsDragging(param => true);
      startYRef.current = clientY;
      return;
    }
  };
  let handleMouseDown = e => {
    e.preventDefault();
    handleStart(e.clientY);
  };
  let handleTouchStart = e => handleStart(getTouchClientY(e));
  let handleMove = clientY => {
    if (!(isDragging && !isDisabled)) {
      return;
    }
    let deltaY = clientY - startYRef.current;
    let progress = Math.min(Math.max(deltaY, 0.0), 80);
    setDragProgress(param => progress);
  };
  let handleEnd = () => {
    if (isDragging && !isDisabled) {
      setIsDragging(param => false);
      if (dragProgress >= 80 && onPull !== undefined) {
        onPull();
      }
      return setDragProgress(param => 0.0);
    }
  };
  let handleClick = _e => {
    if (!isDisabled && !isDragging && dragProgress <= 5.0 && onPull !== undefined) {
      return onPull();
    }
  };
  React.useEffect(() => {
    if (!isDragging) {
      return;
    }
    let handleGlobalMouseMove = e => handleMove(e.clientY);
    let handleGlobalTouchMove = e => {
      let touches = e.touches;
      let touch = touches[0];
      if (touch !== undefined) {
        return handleMove(Primitive_option.valFromOption(touch).clientY);
      }
    };
    let handleGlobalEnd = param => handleEnd();
    addWindowListeners(handleGlobalMouseMove, handleGlobalTouchMove, handleGlobalEnd);
    return () => removeWindowListeners(handleGlobalMouseMove, handleGlobalTouchMove, handleGlobalEnd);
  }, [
    isDragging,
    dragProgress
  ]);
  let progressPercent = dragProgress / 80 * 100.0;
  let ticketOffset = Math.min(dragProgress * 0.5, 40.0);
  let dispenserStyle = makeStyle({
    cursor: isDisabled ? "not-allowed" : "grab",
    opacity: isDisabled ? "0.7" : "1"
  });
  let ticketStyle = makeStyle({
    transform: `translateY(` + ticketOffset.toString() + `px)`,
    opacity: (progressPercent / 100.0).toString()
  });
  let innerTicketStyle = makeStyle({
    padding: "0.75rem"
  });
  let innerContentStyle = makeStyle({
    fontSize: "2rem",
    fontWeight: "900",
    textAlign: "center"
  });
  let pullIndicatorStyle = makeStyle({
    position: "absolute",
    bottom: "-30px",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "0.75rem",
    color: "var(--color-gray)"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Take a Number",
            className: "dispenser-label"
          }),
          JsxRuntime.jsx("div", {
            children: isDisabled ? "Please wait..." : "↓ Tap or drag down ↓",
            className: "dispenser-hint"
          }),
          JsxRuntime.jsx("div", {
            className: "dispenser-slot"
          })
        ],
        className: `dispenser ` + (
          isDisabled ? "disabled" : ""
        ),
        "data-testid": "dispenser-pull-area",
        style: dispenserStyle,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onTouchStart: handleTouchStart
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: "?",
            style: innerContentStyle
          }),
          className: "paper-ticket",
          style: innerTicketStyle
        }),
        className: `ticket-emerging ` + (
          dragProgress > 0.0 ? "pulling" : ""
        ),
        "data-testid": "ticket-preview",
        style: ticketStyle
      }),
      isDragging ? JsxRuntime.jsx("div", {
          children: progressPercent >= 100.0 ? "Release!" : `Pull... ` + (Math.round(progressPercent) | 0).toString() + `%`,
          className: "pull-indicator",
          style: pullIndicatorStyle
        }) : null
    ],
    className: "dispenser-container",
    "data-testid": "dispenser"
  });
}

function expose() {
  Preact.setWindowProperty("Dispenser", Dispenser);
}

let pullThreshold = 80;

let make = Dispenser;

export {
  makeStyle,
  pullThreshold,
  getClientY,
  getTouchClientY,
  addWindowListeners,
  removeWindowListeners,
  make,
  expose,
}
/* react Not a pure module */
